/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".swiper-button-next[_ngcontent-%COMP%], .swiper-button-prev[_ngcontent-%COMP%]{top:43px;background-size:15px 27px}.swiper-button-prev[_ngcontent-%COMP%]{background-image:url(/assets/images/arrow/c-left_.png)}.swiper-button-next[_ngcontent-%COMP%]{background-image:url(/assets/images/arrow/c-right_@2x.png)}.swiper-slide[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center}"];
export { styles as styles };
